import { useEffect } from 'react';
import { ChevronRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useBulkImportStore } from '@/stores';
import { ROUTE } from '@/config';
import { toast } from '@/hooks/use-toast';
import { ToastAction } from '@/components/ui/toast';
import { CarrierSettings } from '@/components/ShippingRules/CarrierSettings';
import { ShippingLockBanner } from '@/components/ShippingRules/ShippingLockBanner';
import { useGetShippingRulesMode } from '@/hooksApi/useShippingRule';

const SettingsCarriers = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { getDraft } = useBulkImportStore();

  // Item 1 — Lock Shipping Rules. When locked the merchant cannot toggle any
  // carrier on/off; the backend also 403s the toggle-active write.
  const { data: modeData } = useGetShippingRulesMode();
  const isLocked = modeData?.object?.lock_shipping_rules ?? false;

  useEffect(() => {
    const draft = getDraft();
    if (draft) {
      const { dismiss } = toast({
        title: t('unfinished_bulk_import'),
        duration: Infinity,
        action: (
          <ToastAction
            altText={t('return_to_bulk_import')}
            onClick={() => {
              dismiss();
              navigate(`${ROUTE.IMPORT}?autoResume=true`);
            }}
            className='bg-sd-primary text-sd-primary-foreground hover:bg-sd-primary/90'
          >
            {t('return_to_bulk_import')}
          </ToastAction>
        ),
      });
      return () => {
        dismiss();
      };
    }
  }, [getDraft, navigate, t]);

  return (
    <div className='sd-scope sd-font flex flex-col'>
      <div className='px-4 sm:px-8 py-4 sm:py-6 space-y-4'>
        {/* Breadcrumb */}
        <nav className='flex items-center gap-1.5 text-sm text-sd-muted-foreground'>
          <span>{t('settings')}</span>
          <ChevronRight className='h-3.5 w-3.5' strokeWidth={1.5} />
          <span className='text-sd-foreground font-medium'>{t('carriers')}</span>
        </nav>

        {isLocked && <ShippingLockBanner />}

        <div className='rounded-2xl border border-sd-border bg-sd-card shadow-sm'>
          <CarrierSettings locked={isLocked} />
        </div>
      </div>
    </div>
  );
};

export default SettingsCarriers;
